import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { LoadingIndicator } from 'common/components/preloader';
import { TABLET_BREAKPOINT_PX } from 'common/variables';
import { ProfileMeta } from 'profile/containers/meta';
import { getCanonicalURL } from 'common/utils';

export default class Profile extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      params, fetchProfileIfNeeded, fetchLanguagesIfNeeded, fetchCategoriesIfNeeded,
    } = this.props;

    this.props.fetchLanguagesIfNeeded();
    this.props.fetchCategoriesIfNeeded();
    fetchProfileIfNeeded(params.profileUsername);
  }

  componentDidUpdate(prevProps) {
    const { params, fetchProfileIfNeeded } = this.props;
    if (prevProps.params.profileUsername !== params.profileUsername) {
      fetchProfileIfNeeded(params.profileUsername);
    }
  }

  render() {
    const { children, isLoading, data, portfolioState, params } = this.props;

    if (isLoading || !data) {
      return <LoadingIndicator />;
    }

    const componentClasses = classNames('profile-page l-content', {
      'mobile-portfolio': (
        typeof window !== 'undefined' &&  // handle missing window obj when server-rendering
        window.innerWidth < TABLET_BREAKPOINT_PX &&
        portfolioState.detailsMode
      ),
    });

    return (
      <div className={componentClasses} id="content">
        <ProfileMeta />
        { children }
      </div>
    );
  }
}

Profile.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.object,
  portfolioState: PropTypes.object,
  user: PropTypes.shape({
    logged_in: PropTypes.bool,
    profile_data: PropTypes.object,
  }),
  children: PropTypes.node,
  params: PropTypes.shape({
    profileUsername: PropTypes.string,
  }),
  router: PropTypes.object,
  fetchProfileIfNeeded: PropTypes.func.isRequired,
  fetchLanguagesIfNeeded: PropTypes.func.isRequired,
  fetchCategoriesIfNeeded: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./profile/components/index.jsx